import React from 'react';
import '../App.css';

const TermsOfService: React.FC = () => {
    return (
        <div style={{ padding: '4rem 2rem', maxWidth: '800px', margin: '0 auto', color: '#333' }}>
            <h1 style={{ marginBottom: '1rem', fontSize: '2.5rem', color: '#000' }}>Terms of Service</h1>
            <p style={{ marginBottom: '2rem', color: '#666' }}>Last updated: {new Date().toLocaleDateString()}</p>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>1. Introduction</h2>
                <p>
                    Welcome to Chibs Olympia. By accessing our website and purchasing our services, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using or accessing this site.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>2. Services</h2>
                <p>
                    Chibs Olympia provides online fitness coaching, nutritional guidance, and training programs. We reserve the right to modify or discontinue any service at any time without notice.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>3. Medical Disclaimer</h2>
                <p style={{ fontWeight: 'bold', color: '#d32f2f' }}>
                    Standard Medical Disclaimer:
                </p>
                <p>
                    You should consult your physician or other health care professional before starting this or any other fitness program to determine if it is right for your needs. This is particularly true if you (or your family) have a history of high blood pressure or heart disease, or if you have ever experienced chest pain when exercising or have experienced chest pain in the past month when not engaged in physical activity, smoke, have high cholesterol, are obese, or have a bone or joint problem that could be made worse by a change in physical activity. Do not start this fitness program if your physician or health care provider advises against it.
                </p>
                <p style={{ marginTop: '1rem' }}>
                    If you experience faintness, dizziness, pain or shortness of breath at any time while exercising you should stop immediately.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>4. Intellectual Property</h2>
                <p>
                    The materials contained in this website and our programs are protected by applicable copyright and trademark law. You may not distribute, exchange, modify, sell, or transmit anything you copy from this Site, including but not limited to any text, images, audio, and video, for any business, commercial, or public purpose.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>5. Limitation of Liability</h2>
                <p>
                    In no event shall Chibs Olympia be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Chibs Olympia's website, even if Chibs Olympia or a Chibs Olympia authorized representative has been notified orally or in writing of the possibility of such damage.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>6. Refund Policy</h2>
                <p>
                    Due to the nature of digital products and online coaching, all sales are final. Refunds will only be issued at our sole discretion or where required by law.
                </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#111' }}>7. Contact Us</h2>
                <p>
                    If you have any questions about these Terms, please contact us at: <br />
                    <a href="mailto:olympiaacademy@chibsolympia.com" style={{ color: '#0056b3', textDecoration: 'none', fontWeight: 'bold' }}>olympiaacademy@chibsolympia.com</a>
                </p>
            </section>
        </div>
    );
};

export default TermsOfService;
